<nav class="navbar navbar-expand-lg navbar-light bg-light mb-3">
  <a *ngIf="!iframeMode" class="navbar-brand" [href]="homeLinkHref">{{homeLinkText}}</a>

  <!-- Step 3: Toggle the value of the property when the toggler button is clicked. -->
  <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
    &#9776;
  </button>

  <!-- Step 2: Add the ngbCollapse directive to the element below. -->
  <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
    <ul class="navbar-nav ml-auto">
      
      <li class="nav-item" *ngIf="!loggedIn">
        <a class="nav-link" [routerLink]="['/login']" (click)="isMenuCollapsed = true">Log ind</a>
      </li>

      <li class="nav-item" *ngIf="!loggedIn">
        <a class="nav-link" [routerLink]="['/signup']" (click)="isMenuCollapsed = true">Opret bruger</a>
      </li>
      <li class="nav-item" *ngIf="loggedIn">
        <a *ngIf="systemType == 'udlaan'" class="nav-link" [routerLink]="['/allgear']" (click)="isMenuCollapsed = true">Lånebanken</a>
        <a *ngIf="systemType == 'foraering'" class="nav-link" [routerLink]="['/allgear']" (click)="isMenuCollapsed = true">Til afhentning</a>
      </li>
      <li class="nav-item" *ngIf="loggedIn && isAdmin">
        <a class="nav-link" [routerLink]="['/admin']" (click)="isMenuCollapsed = true">Administration</a>

      </li>
      <!--<li class="nav-item" *ngIf="loggedIn">
        <a class="nav-link" [routerLink]="['/mygear']" (click)="isMenuCollapsed = true">Mit udstyr</a>
      </li>-->
      <li class="nav-item" *ngIf="loggedIn">
        <a class="nav-link" routerLink="" (click)="logout()" style="color:red">Log ud</a>
      </li>
    </ul>
  </div>
</nav>
<div class="container" *ngIf="hasCheckedLogin">
  <router-outlet></router-outlet>
</div>